import getCorePersonalStore from "../../../../../../../stores/core/core-personal-store";
import getUserAdvancedStore from "../../../../../../../stores/user-store/advanced-store";
import { TDescriptionType } from "../../../../../../../Types";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import DescriptionDataSolve from "../data-actions/DescriptionSolve";
import DescriptionBody from "./DescriptionBody";
import DescriptionHeader from "./DescriptionHeader";
import DescriptionStatusImage from "./DescriptionStatusImage";

const Description = withLiteObserverAndTheme<{
  userID: number;
  descriptionId: number;
  descriptionStatus: string;
  descriptionType: TDescriptionType;
  description: string;
  descriptionAlignment: "left" | "right";
}>((props) => {
  const {
    theme,
    userID,
    descriptionId,
    descriptionStatus,
    descriptionType,
    description,
    descriptionAlignment
  } = props;
  const { colors, unitX } = theme;
  const isPendingDescription = descriptionStatus === "PENDING";
  const isAcceptedDescription = descriptionStatus === "APPROVED";
  const imageStatusLogoSource = isPendingDescription
    ? "pending-logo"
    : isAcceptedDescription
      ? "accepted-logo"
      : "rejected-logo";
  const descriptionBorderColor = isPendingDescription
    ? colors.all.davysGrey
    : isAcceptedDescription
      ? colors.all.seaGreen
      : colors.all.red;
  const isUserDeleted = getUserAdvancedStore().isUserStatusDeleted.get();
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const canSolveDescription = !isUserDeleted && !isAnyKhattabaAdmin;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={450}
      height={310}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="column"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={450}
        height={224}
        color={colors.all.white}
        style={{
          borderRadius: `${39 * unitX}px`,
          border: `${5 * unitX}px solid ${descriptionBorderColor}`
        }}
        onClick={() => {}}
      >
        <DescriptionHeader descriptionType={descriptionType} />
        <DescriptionBody
          description={description}
          descriptionAlignment={descriptionAlignment}
        />
        <DescriptionStatusImage
          description={description}
          imageStatusLogoSource={imageStatusLogoSource}
        />
      </ET3Div>
      {canSolveDescription ? (
        <DescriptionDataSolve
          userID={userID}
          description={description}
          descriptionID={descriptionId}
          descriptionStatus={descriptionStatus}
          descriptionType={descriptionType}
          isPendingDescription={isPendingDescription}
        />
      ) : null}
    </ET3Div>
  );
});

export default Description;
